export const lssLangCn = {
    contact: {
        contactList: '联系人列表',
        callLog: '通话记录',
        name: '姓名',
        phone: '手机号',
        close: '关闭',
        check: '查看',
        searchName: '搜索姓名',
        lastDialTime: '最后通话时间',
        numberOfCalls: '通话次数'
    },
};
